import React, { useEffect } from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import {
  Grid, Button, Paper, Typography, CssBaseline,
} from '@mui/material';
import { useGoogleLogin } from '@react-oauth/google';
import { useMsal } from '@azure/msal-react';
import api from '../lib/api';

const styles = {
  layout: {
    width: 'auto',
    maxWidth: 450,
    display: 'block', // Fix IE 11 issue.
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

function Login({ auth, history }) {
  useEffect(() => {
    if (auth.isAuthenticated()) {
      // eslint-disable-next-line no-console
      console.log('authenticated, going home');
      goTo('home');
    }
  }, []);

  // Auth0 methods
  function goTo(route) {
    history.replace(`/${route}`);
  }

  function goToOperatorAsWrangler(wrangler) {
    if (isNil(wrangler)) {
      console.warn('did not find a matching wrangler for the logged in user');
      return;
    }
    const userId = get(wrangler, '_id');
    const phoneNumber = get(wrangler, 'phoneNumber');

    const userMarketPreferences = get(wrangler, 'adminMarketIds', []);
    localStorage.setItem('userPhone', phoneNumber);
    localStorage.setItem('userMarketPreferences', JSON.stringify(userMarketPreferences));
    localStorage.setItem('userId', userId);
    // for some reason, goTo is bound to 'home', so use history directly.
    history.replace('/operator');
  }

  function responseGoogle(user, err) {
    if (err) {
      console.error(err);
    }
    const code = get(user, 'code');
    api.checkToken(code)
      .then((auth) => {
        const token = get(auth, 'token');
        const refreshToken = get(auth, 'refreshToken');
        const email = get(auth, 'user.email');
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        return api.getUserFromEmail(email);
      })
      .then(goToOperatorAsWrangler)
      .catch((e) => {
        console.error(e);
        auth.logout();
      });
  }

  function googleError(err) {
    console.error('oh no error from google login', err);
  }

  const login = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: googleError,
    flow: 'auth-code',
  });

  const { instance: msalInstance } = useMsal();

  function responseMicrosoft() {
    msalInstance.loginPopup({ scopes: ['openid', 'profile', 'email'] })
      .then((result) => {
        const idToken = get(result, 'idToken');
        return api.checkTokenMicrosoft(idToken)
          .then((msAuth) => {
            const email = get(msAuth, 'user.email');
            localStorage.setItem('token', idToken);
            return api.getUserFromEmail(email);
          });
      })
      .then(goToOperatorAsWrangler)
      .catch((e) => {
        console.error('oh no error from microsoft login', e);
        auth.logout();
      });
  }

  return (
    <div>
      <CssBaseline />
      {!auth.isAuthenticated()
        && (
          <main style={styles.layout}>
            <Paper
              sx={{
                width: 'fit-content',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0 auto',
                mt: 8,
                py: 4,
                px: 6,
              }}
            >
              <Grid sx={{ mb: 3 }}>
                <Typography component="h1" variant="h5">Login to your account</Typography>
              </Grid>
              <Button
                variant="contained"
                onClick={() => login()}
                color="primary"
              >
                Login with Google
              </Button>
              <Button
                variant="contained"
                onClick={responseMicrosoft}
                color="primary"
                sx={{ mt: 2 }}
              >
                Login with Microsoft
              </Button>
            </Paper>
          </main>
        )}
    </div>
  );
}

export default Login;
